export const state = {
  modalViewPurchase: false,
  purchases: [],
  purchase: {
    purchase_type: "",
    price: 0
  }
};

export default {};
